module.exports = __webpack_public_path__ + "img/icon-walking.940cfef2.svg";